import React from "react";
import styles from "./FooterV2.scss";
import MCULogoBlack from "../../../../assets/images/MCU_Logo_Black.png";

export function FooterV2() {
  const scrollToSection = sectionId => {
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  const scrollToTop = () => {
    setTimeout(() => {
      const heroSection = document.querySelector('[class*="hero-area"]');
      if (heroSection) {
        heroSection.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    }, 100);
  };

  const openAboutTab = tab => {
    window.dispatchEvent(new CustomEvent("openAboutTab", { detail: { tab } }));
  };

  const openContactModal = () => {
    window.dispatchEvent(new CustomEvent("openContactModal"));
  };

  const openPrivacyModal = () => {
    window.dispatchEvent(new CustomEvent("openPrivacyModal"));
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.footerContent}>
          {/* Left Section - Tagline and Logo */}
          <div className={styles.leftSection}>
            <div className={styles.tagline}>
              <p className={styles.taglineText}>やりたいが、カタチになる</p>
              <p className={styles.taglineText}>共想から共創が生まれるメタバースキャンパス</p>
            </div>

            <div className={styles.logo}>
              <img src={MCULogoBlack} alt="MetaCampUs" className={styles.logoImage} />
            </div>

            <button type="button" onClick={openContactModal} className={styles.contactButton}>
              お問い合わせ
              <span className={styles.contactIcon}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="#E85A9C" />
                  <path d="M12 8L12 16M8 12L16 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </span>
            </button>
          </div>

          {/* Right Section - Navigation Links */}
          <div className={styles.rightSection}>
            <div className={styles.navColumn}>
              <button type="button" onClick={scrollToTop} className={styles.navLink}>
                Home
              </button>
              <button type="button" onClick={() => scrollToSection("vision")} className={styles.navLink}>
                Vision
              </button>
              <button type="button" onClick={() => scrollToSection("worlds")} className={styles.navLink}>
                Worlds
              </button>
              <button type="button" onClick={() => scrollToSection("voice")} className={styles.navLink}>
                Voice
              </button>
            </div>
            <div className={styles.navColumn}>
              <button type="button" onClick={() => openAboutTab("terms")} className={styles.navLink}>
                利用規約
              </button>
              <button type="button" onClick={() => openAboutTab("faq")} className={styles.navLink}>
                よくある質問
              </button>
              <button type="button" onClick={() => openAboutTab("guide")} className={styles.navLink}>
                操作説明
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Info - プライバシーポリシーとコピーライト */}
        <div className={styles.bottomInfo}>
          <button type="button" onClick={openPrivacyModal} className={styles.bottomLink}>
            プライバシーポリシー
          </button>
          <span className={styles.copyright}>© 2026- 東京科学大学 辻本研究室</span>
        </div>
      </div>
    </footer>
  );
}
